import React, { useEffect, useState } from 'react';
import { getDashboard, getQueueSummary } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [queues, setQueues] = useState(null);

  useEffect(() => {
    getDashboard().then(r => setStats(r.data)).catch(() => {});
    getQueueSummary().then(r => setQueues(r.data)).catch(() => {});
  }, []);

  const StatCard = ({ label, value, icon, color }) => (
    <div style={{ background: '#ffffff', border: '1px solid #dee2e6', borderRadius: 14, padding: '20px 22px' }}>
      <div style={{ fontSize: 26, marginBottom: 10 }}>{icon}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color }}>{value ?? '...'}</div>
      <div style={{ fontSize: 13, color: '#495057', marginTop: 4 }}>{label}</div>
    </div>
  );

  const QueueCard = ({ title, color, items }) => (
    <div style={{ background: '#ffffff', border: '1px solid #dee2e6', borderRadius: 14, padding: 20 }}>
      <div style={{ fontWeight: 700, fontSize: 14, color, marginBottom: 14 }}>{title}</div>
      {items.map(([label, value]) => (
        <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e9ecef' }}>
          <span style={{ fontSize: 13, color: '#495057' }}>{label}</span>
          <span style={{ fontSize: 15, fontWeight: 700, color }}>{value ?? 0}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <h1 style={{ fontSize: 26, fontWeight: 700, marginBottom: 4, color: '#212529' }}>Dashboard</h1>
      <p style={{ color: '#6c757d', fontSize: 14, marginBottom: 28 }}>
        Welcome back, {user?.name} · {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 28 }}>
        <StatCard label="Today's Orders" value={stats?.today_orders} icon="📦" color="#38bdf8" />
        <StatCard label="Today's Revenue" value={stats ? `$${stats.today_revenue.toFixed(2)}` : null} icon="💰" color="#22c55e" />
        <StatCard label="Pending Orders" value={stats?.pending_orders} icon="⏳" color="#f59e0b" />
        <StatCard label="No Contact" value={stats?.no_contact_pending} icon="📵" color="#ef4444" />
      </div>

      {queues && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16 }}>
          <QueueCard title="🏙 Phnom Penh Queue" color="#38bdf8" items={[
            ['Ready to Pack', queues.phnom_penh?.ready_to_pack],
            ['Packed', queues.phnom_penh?.packed],
            ['On Hold', queues.phnom_penh?.hold],
          ]} />
          <QueueCard title="🗺 Province Queue" color="#a78bf8" items={[
            ['Waiting Payment', queues.province?.waiting_payment],
            ['Ready to Pack', queues.province?.ready_to_pack],
            ['Packed', queues.province?.packed],
          ]} />
          <QueueCard title="📵 No Contact Queue" color="#ef4444" items={[
            ['Pending Follow-up', queues.no_contact?.pending_followup],
            ['Overdue', queues.no_contact?.overdue],
          ]} />
        </div>
      )}
    </div>
  );
}